export const PageAnimation = {
    in:{
        opacity:0
    },
    out:{
        opacity:1
    },
    exit:{
        opacity:1
    }
}